<script setup lang="ts">
    const props = defineProps<{ blok: TableComponentStoryblok }>();
</script>

<template>
    <table v-editable="props.blok">
        <caption v-if="props.blok?.caption?.length">
            <StoryblokComponentWrapper
                v-for="caption in props.blok.caption"
                :key="caption._uid"
                :blok="caption"
            />
        </caption>
        <thead>
            <tr :class="[`cols-${props.blok?.tableHeaders?.length}`, { 'sr-only': props.blok?.hideTableHeaders }]">
                <th
                    v-for="(th, index) in props.blok?.tableHeaders"
                    :key="'th-' + index"
                >
                    <StoryblokComponentWrapper :blok="th" />
                </th>
            </tr>
        </thead>
        <tbody>
            <StoryblokComponentWrapper
                v-for="row in props.blok?.tableRows"
                :key="row._uid"
                :blok="row"
            />
        </tbody>
    </table>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/table/table.scss';
</style>
